import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import SeriesJsonMarkup from './series-json-markup/SeriesJsonMarkup';
import { getAuthorFullName } from '@/helpers/helpers';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { ISeriesBooksPage, ISeriesBooksList } from '@/interfaces/seriesBooksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

interface ISeriesBooksPageProps {
  books: ISeriesBooksPage;
}

const SeriesDetail: FC<ISeriesBooksPageProps> = ({ books }) => {
  const seriesBooks = books.data[0].books_list;
  const seriesTitle = books.data[0].title;
  const seriesId = books.data[0].id;

  const authorFullName = getAuthorFullName(seriesBooks[0]?.author.first_name, seriesBooks[0]?.author.middle_name, seriesBooks[0]?.author.last_name);

  const pagesCount = Math.ceil(books.data[0].book_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `${seriesTitle}${authorFullName.length > 0 ? `, ${authorFullName}` : ``} - скачать бесплатно fb2, epub`;
  const SEO_DESCRIPTION = `${seriesTitle} ⏩ скачать бесплатно fb2, epub, pdf и без регистрации${authorFullName.length > 0 ? `, ✨${authorFullName}` : ``}. 📚 Электронная библиотека КучаКниг`;
  const SEO_CANONICAL = `/series/${seriesId}/`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <SeriesJsonMarkup data={books} />
      <Breadcrumbs pageName="Серии и саги" pageAlias="/series/" dynamicPageName={`${seriesTitle}`} />

      <SectionTitleMenu>
        <PageHeading title={`Серия книг ${seriesTitle}`} extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {seriesBooks && seriesBooks.length > 0 ? (
          seriesBooks.map((book: ISeriesBooksList) => <BookCardItem createdAt={book.created_at} alias={book.alias} author={book.author} book={book.book} rating={book.rating} key={book.id} draft={book.draft} readOnline />)
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`series/${seriesId}/page=`} />
      {/* <Breadcrumbs pageName="Серии и саги" pageAlias="/series/" dynamicPageName={`${seriesTitle}`} isBottom={true} /> */}
    </Layout>
  );
};

export default SeriesDetail;
